import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetect from "i18next-browser-languagedetector";
import { localeKeys, locales } from "./locales/index.ts";
import { syncHtmlLanguageAttributes } from "./util/i18n.functions.ts";

i18next
  .use(initReactI18next)
  .use(LanguageDetect)
  .init({
    supportedLngs: localeKeys,
    fallbackLng: localeKeys[0],
    debug: true,
    detection: {
      // Swedish is the product default (see App.tsx); English is opt-in via Account.
      order: ["localStorage"],
      caches: ["localStorage"],
      lookupLocalStorage: "i18nextLng",
    },
    resources: {
      sv: {
        translation: locales.sv,
      },
      en: {
        translation: locales.en,
      },
    },
  });

i18next.on("languageChanged", (lng) => {
  syncHtmlLanguageAttributes(lng);
});

syncHtmlLanguageAttributes(i18next.language || localeKeys[0]);
